import { useMemo } from 'react';
import { useEffectiveConfiguration } from '@/features/societies/hooks/useSocietyConfiguration';
import { BASE_DURATION_OPTIONS, EXTENDED_DURATION_OPTIONS, type DurationOption } from '../types/warranty.types';

/**
 * Retourne les durées autorisées pour une société donnée
 *
 * Règles :
 * - Si societyId === undefined (utilisateur INTERNAL) : toutes les durées
 * - Si config.extendedDuration === true : toutes les durées
 * - Sinon : durées de base uniquement [3, 6, 12, 24]
 */
export const useAllowedDurations = (societyId: string | undefined): DurationOption[] => {
  const { data: config } = useEffectiveConfiguration(societyId);

  return useMemo(() => {
    if (societyId === undefined) {
      return [...BASE_DURATION_OPTIONS, ...EXTENDED_DURATION_OPTIONS];
    }

    if (!config) {
      return [...BASE_DURATION_OPTIONS];
    }

    if (config.extendedDuration) {
      return [...BASE_DURATION_OPTIONS, ...EXTENDED_DURATION_OPTIONS];
    }

    return [...BASE_DURATION_OPTIONS];
  }, [societyId, config]);
};
